import React from 'react'
import { Select as ArcoSelect } from '@arco-design/web-react'
import cx from 'classnames'
import styles from './index.module.less'

type Props = React.ComponentProps<typeof ArcoSelect>

const Select = (props: Props) => {
  const { className, ...restProps } = props

  return <ArcoSelect className={cx(styles.select, className)} {...restProps} />
}

export default Select
